// Every PDF we render was uploaded by someone else. pdf.js's eval-based font
// path ran attacker code from a crafted font (CVE-2024-4367), so keep it off.
// One shared object: react-pdf reloads the document if `options` changes identity.
export const PDF_DOCUMENT_OPTIONS = { isEvalSupported: false };

export const safeGetDocumentParams = (params) => ({ ...params, isEvalSupported: false });
